import {
  Card,
  ControlledDatePicker,
  ControlledTextField,
} from '../../../../shared/components';
import QuotationSection from '../components/QuotationSection';
import SanctioningAuthoritySection from '../components/SanctioningAuthoritySection';

/**
 * Sanction & Quotation step.
 *
 * Split out of Basic Details when work_jobs was divided into work_jobs (core
 * project identity) and work_jobs2 (secondary attributes). Every field here is
 * persisted on work_jobs2: sanction_number, sanction_date,
 * sanctioning_authority_id, letterhead and signature.
 */
export default function StepSanctionDetails() {
  return (
    <Card title='Sanction & Quotation'>
      <div className='grid grid--2-cols grid--with-divider '>
        <div className='column'>
          <ControlledTextField
            id='sanctionNumber'
            name='details.sanction.number'
            label='Sanction number'
            placeholder='Enter Sanction number'
            rules={{}}
            showErrorInline
          />
        </div>

        <div className='column'>
          <ControlledDatePicker label='Sanction date' id='sanctionDate' name='details.sanction.date' />
        </div>
      </div>

      <SanctioningAuthoritySection />

      <QuotationSection />
    </Card>
  );
}
